export default __webpack_public_path__ + "static/media/daylight full circle 6.19.0d0b7dd1.png";